import React from 'react';
import { Link } from 'react-router-dom';
import { MapPin } from 'lucide-react';
import { VILLES, villeUrl, villesProches, getVille } from '../data/villes';

/** Liens internes vers les communes voisines (maillage SEO local). */
const VillesVoisines = ({ slug, titre }) => {
  const current = getVille(slug);
  const villes = current ? villesProches(current, 10) : VILLES.slice(0, 10);

  return (
    <section className="py-12 px-4 bg-gray-50" data-testid="villes-voisines">
      <div className="max-w-4xl mx-auto">
        <h2 className="text-2xl md:text-3xl font-bold text-gray-900 mb-2 flex items-center gap-2">
          <MapPin className="w-6 h-6 text-blue-600" />
          {titre || 'Nous intervenons aussi à proximité'}
        </h2>
        <p className="text-gray-600 mb-6">
          Réparation iPhone et Samsung à domicile ou à l'atelier pour les habitants de :
        </p>
        <div className="flex flex-wrap gap-2">
          {villes.map((ville) => (
            <Link
              key={ville.slug}
              to={villeUrl(ville)}
              data-testid={`ville-link-${ville.slug}`}
              className="px-4 py-2 bg-white border border-gray-200 rounded-full text-gray-800 text-sm font-medium hover:border-blue-500 hover:text-blue-600 transition-colors"
            >
              {ville.nom}
            </Link>
          ))}
          <Link
            to="/zones-intervention"
            data-testid="ville-link-toutes"
            className="px-4 py-2 bg-blue-600 text-white rounded-full text-sm font-semibold hover:bg-blue-700 transition-colors"
          >
            Toutes les communes de la Loire (42) →
          </Link>
        </div>
      </div>
    </section>
  );
};

export default VillesVoisines;
